import { useSyncExternalStore } from 'react';

// Super-admin Hints rail preference. ON BY DEFAULT: an absent key reads as
// enabled, so a super admin who has never toggled it sees the rail. Mirrors the
// in-memory subscription mechanism of superAdminDebugOverlayPreference.ts.
const STORAGE_KEY = 'sg.superAdminHints.enabled';
const listeners = new Set<() => void>();

function notifyListeners() {
  listeners.forEach((listener) => listener());
}

export function getSuperAdminHintsEnabled() {
  if (typeof window === 'undefined') {
    return true;
  }

  // Absent key → ON by default. Only an explicit 'false' turns it off.
  return window.localStorage.getItem(STORAGE_KEY) !== 'false';
}

export function setSuperAdminHintsEnabled(enabled: boolean) {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, String(enabled));
  notifyListeners();
}

export function subscribeToSuperAdminHintsPreference(listener: () => void) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function useSuperAdminHintsPreference() {
  return useSyncExternalStore(
    subscribeToSuperAdminHintsPreference,
    getSuperAdminHintsEnabled,
    () => true,
  );
}
